import { render, staticRenderFns } from "./circles-play-icon.vue?vue&type=template&id=315104a5&scoped=true"
import script from "./circles-play-icon.vue?vue&type=script&lang=js"
export * from "./circles-play-icon.vue?vue&type=script&lang=js"
import style0 from "./circles-play-icon.vue?vue&type=style&index=0&id=315104a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315104a5",
  null
  
)

export default component.exports